import { useEffect, useState } from "react"
import { getCanCreate, updateCanCreate } from "../../Api/ApiUrlConst";
import { Button, Spinner } from "reactstrap";

const AdminTaskSettings = () => {
    const [canCreate, setCanCreate] = useState<boolean>(false);
    const [loading, setLoading] = useState<boolean>(false);

    useEffect(()=>{
        loadStatus();
    },[]);


    const loadStatus = async () => {
        setLoading(true);
        const value = await getCanCreate();
        setCanCreate(value);
        setLoading(false);
    }

    const toggleCreateButton=async()=>{
        await updateCanCreate(!canCreate);
        setCanCreate(!canCreate);
    };

    if(loading) return <Spinner/>;

    return(
<Button color={canCreate ? "danger" : "success"} onClick={toggleCreateButton}>
    {canCreate ? "Disable Task Creation" : "Enable Task Creation"}

</Button>
    );


}

export default AdminTaskSettings;